import { gql } from '@apollo/client';
import { CarePlan, PagedListInfo } from '../../models';

export type GetList_ResponseData = {
  carePlan: {
    list: {
      items: CarePlan[];
      pageInfo: PagedListInfo;
    };
  };
};

export const GET_LIST = gql`
  query PlanDefinitionPagination(
    $page: Int!
    $perPage: Int!
    $filter: FilterFindManyPlanDefinition!
  ) {
    planDefinition {
      planDefinitionPagination(
        page: $page
        perPage: $perPage
        filter: $filter
      ) {
        pageInfo {
          page
          perPage
          totalItems
        }
        items {
          id
          status
          title
          subtitle
          type
          actorReferences {
            careTeam {
              id
              name
            }
          }
        }
      }
    }
  }
`;
